import React, { useEffect, useMemo, useState } from "react";

const orgId = "6a3ba96dc8e05c65af7f0ef0";

// Life stages don't come with images/copy from the API — map them here
const lifeStageImages = {
  "Adolescence": "/images/lifestages/adolescence.jpg",
  "Reproductive Age": "/images/lifestages/reproductive.jpg",
  "Pregnancy": "/images/lifestages/pregnancy.jpg",
  "Perimenopause": "/images/lifestages/perimenopause.jpg",
  "Menopause": "/images/lifestages/menopause.jpg",
};

const lifeStageSubtitles = {
  "Adolescence": "Feel confident through every stage of growing up.",
  "Reproductive Age": "Comprehensive care through your reproductive years.",
  "Pregnancy": "Guiding you through every trimester with care.",
  "Perimenopause": "Support through the transition with confidence.",
  "Menopause": "Navigate menopause with expert guidance.",
};

const groupByLifeStage = (services) => {
  const map = {};
  services
    .filter((s) => s.status !== "INACTIVE")
    .forEach((service) => {
      (service.lifeStages || []).forEach((stage) => {
        if (!map[stage.id]) {
          map[stage.id] = { ...stage, services: [] };
        }
        map[stage.id].services.push(service.serviceName);
      });
    });
  return Object.values(map);
};

const LifeStages = ({ services = [], loading }) => {
  // const [stages, setStages] = useState([]);
  console.log(services,"vvvvvvvvvvvvv`")
  const stages = useMemo(() => groupByLifeStage(services), [services]);
 if (loading) return null; // or a skeleton
  if (!stages.length) return null;
 
  return (
    <section className="w-full py-10 md:py-14">
      <div className="container mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">
          {stages.map((stage) => (
            <LifeStageCard key={stage.id} stage={stage} />
          ))}
        </div>
      </div>
    </section>
  );
};

const LifeStageCard = ({ stage }) => {
  const { name, minAge, maxAge, services } = stage;

  const ageLabel =
    minAge != null && maxAge != null
      ? `${name} (${minAge}-${maxAge})`
      : minAge != null
      ? `${name} (${minAge}+)`
      : name;

  const image = lifeStageImages[name] || "/images/default-lifestage.jpg";
  const subtitle =
    lifeStageSubtitles[name] || "Personalized care for this stage of life.";

  const visibleServices = services.slice(0, 3);
  const remaining = services.length - visibleServices.length;

  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-100 flex flex-col h-full">
      <div className="h-48 w-full overflow-hidden">
        <img src={image} alt={name} className="w-full h-full object-cover" />
      </div>

      <div className="p-6 flex flex-col flex-1">
        <h3 className="ava-text-subheading mb-2">{ageLabel}</h3>
        <p className="ava-text-body mb-4">{subtitle}</p>

        <p className="ava-text-body mb-2" 
        style={{color:"var(--primary-color)"}}>
          AVAILABLE SERVICES
        </p>
        <ul className="space-y-1.5 mb-6 flex-1">
          {visibleServices.map((s, i) => (
            <li key={i} className="flex items-start text-sm text-gray-700">
              <span className="mr-2 text-purple-400">•</span>
              {s}
            </li>
          ))}
          {remaining > 0 && (
            <li className="text-sm text-gray-400 pl-4">+{remaining} more</li>
          )}
        </ul>

        <button
          className="mt-auto self-start flex items-center gap-2 px-5 py-2.5 rounded-full bg-purple-100 text-purple-700 font-medium hover:bg-purple-200 transition-colors"
          onClick={() => {
            // wire to your routing — e.g. navigate(`/services?stage=${stage.id}`)
          }}
        >
          View Services
          <span aria-hidden="true">→</span>
        </button>
      </div>
    </div>
  );
};

export default LifeStages;